/**
 * 企业品牌配置
 * 集中管理品牌相关的所有配置信息
 */

export const brandConfig = {
  // 企业名称
  company: {
    name: '云会议',
    nameEn: 'CloudMeet',
    fullName: '云会议企业版',
    fullNameEn: 'CloudMeet Enterprise',
  },

  // 品牌标语
  slogan: {
    zh: '高效协作，随时随地',
    en: 'Efficient Collaboration, Anytime, Anywhere',
  },

  // 品牌描述
  description: {
    zh: '专业的企业级视频会议解决方案',
    en: 'Professional Enterprise Video Conferencing Solution',
  },

  // 联系方式
  contact: {
    email: 'support@cloudmeet.com',
    phone: '400-xxx-xxxx',
    website: 'https://www.cloudmeet.com',
  },

  // 社交媒体
  social: {
    github: 'https://github.com/your-company',
    twitter: 'https://twitter.com/your-company',
    linkedin: 'https://linkedin.com/company/your-company',
  },

  // 法律信息
  legal: {
    copyright: '© 2025 CloudMeet. All rights reserved.',
    privacyPolicy: '/privacy',
    termsOfService: '/terms',
    icp: '京ICP备xxxxxxxx号', // 如果需要备案号
  },

  // 功能特性
  features: [
    {
      icon: 'Video',
      title: { zh: '高清音视频', en: 'HD Audio & Video' },
      description: { zh: '1080P高清画质，48kHz音频采样', en: '1080P HD quality, 48kHz audio sampling' },
    },
    {
      icon: 'Shield',
      title: { zh: '安全加密', en: 'Secure Encryption' },
      description: { zh: '端到端加密，保护会议隐私', en: 'End-to-end encryption for privacy' },
    },
    {
      icon: 'Monitor',
      title: { zh: '屏幕共享', en: 'Screen Sharing' },
      description: { zh: '支持全屏或应用窗口共享', en: 'Share full screen or application window' },
    },
    {
      icon: 'Users',
      title: { zh: '多人会议', en: 'Multi-party Meeting' },
      description: { zh: '支持最多100人同时在线', en: 'Support up to 100 participants' },
    },
    {
      icon: 'MessageSquare',
      title: { zh: '实时聊天', en: 'Real-time Chat' },
      description: { zh: '会议中即时消息沟通', en: 'Instant messaging during meetings' },
    },
    {
      icon: 'Download',
      title: { zh: '会议录制', en: 'Meeting Recording' },
      description: { zh: '云端录制，随时回放', en: 'Cloud recording, replay anytime' },
    },
  ],

  // 帮助链接
  helpLinks: [
    { label: { zh: '使用指南', en: 'User Guide' }, url: '/help/guide' },
    { label: { zh: '常见问题', en: 'FAQ' }, url: '/help/faq' },
    { label: { zh: '联系支持', en: 'Contact Support' }, url: '/help/support' },
    { label: { zh: '系统要求', en: 'System Requirements' }, url: '/help/requirements' },
  ],
};

// 导出类型
export type BrandConfig = typeof brandConfig;

